import {
	AudienceComposer,
	AudienceMain,
	AudienceModal,
	AudienceProvider,
	type AudienceTabDefinition,
	AudienceTabs,
	AudienceTitle,
} from "@di-devs/audience-feature-plugin/client";
import { BaseAnimationComponent } from "@/components";
import MemberAudienceModal from "./components/MemberAudienceModal";
import MemberAudienceTab from "./components/MemberAudienceTab";
import EventAudienceModal from "./components/EventAudienceModal";
import EventAudienceTab from "./components/EventAudienceTab";

interface Props {
	publicSettings?: any;
}

const Audiences = (props: Props) => {
	// Define tabs for the composer pattern
	const tabs: AudienceTabDefinition[] = [
		{
			label: "会員証オーディエンス",
			content: <MemberAudienceTab />,
			modalContent: (props) => <MemberAudienceModal {...props} />,
		},
		{
			label: "イベントオーディエンス",
			content: <EventAudienceTab />,
			modalContent: (props) => <EventAudienceModal {...props} />,
		},
	];

	return (
		<AudienceProvider publicSettings={props.publicSettings}>
			<BaseAnimationComponent>
				<AudienceComposer tabs={tabs} />
				<AudienceTitle>オーディエンス</AudienceTitle>
				<AudienceTabs className="mb-4" />
				<AudienceMain />

				<AudienceModal />
			</BaseAnimationComponent>
		</AudienceProvider>
	);
};

export default Audiences;
